var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Others"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5 0H0.5V2.10583H25.5V0Z",
    fill: "#DC4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.5 4.22754H0.5V6.33337H25.5V4.22754Z",
    fill: "#DC4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.5 12.6667H0.5V14.7726H25.5V12.6667Z",
    fill: "#DC4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.5 16.8943H0.5V19.0001H25.5V16.8943Z",
    fill: "#DC4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.5 8.43921H0.5V10.545H25.5V8.43921Z",
    fill: "#DC4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.5 2.10571H0.5V4.21155H25.5V2.10571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.5 6.33325H0.5V8.43909H25.5V6.33325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.5 14.7725H0.5V16.8783H25.5V14.7725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.5 10.5608H0.5V12.6666H25.5V10.5608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.9615 0H0.5V10.5608H13.9615V0Z",
    fill: "#2A66B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M3.09612 0.633301L3.53842 1.40913L4.53842 1.5358L3.80765 2.1533L3.98073 3.0083L3.09612 2.59663L2.2115 3.0083L2.38458 2.1533L1.65381 1.5358L2.65381 1.40913L3.09612 0.633301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.0385 0.633301L7.48081 1.40913L8.48081 1.5358L7.76927 2.1533L7.92311 3.0083L7.0385 2.59663L6.15388 3.0083L6.30773 2.1533L5.59619 1.5358L6.59619 1.40913L7.0385 0.633301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.9809 0.633301L11.4232 1.40913L12.4232 1.5358L11.6924 2.1533L11.8655 3.0083L10.9809 2.59663L10.0963 3.0083L10.2693 2.1533L9.53857 1.5358L10.5386 1.40913L10.9809 0.633301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M5.1154 3.80005L5.55771 4.57588L6.55771 4.70255L5.84617 5.32005L6.00002 6.17505L5.1154 5.76338L4.23079 6.17505L4.38463 5.32005L3.6731 4.70255L4.6731 4.57588L5.1154 3.80005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M9.05779 3.80005L9.50009 4.57588L10.5001 4.70255L9.76932 5.32005L9.9424 6.17505L9.05779 5.76338L8.17317 6.17505L8.34625 5.32005L7.61548 4.70255L8.61548 4.57588L9.05779 3.80005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M3.09612 7.15674L3.53842 7.93257L4.53842 8.05924L3.80765 8.6609L3.98073 9.53174L3.09612 9.12007L2.2115 9.53174L2.38458 8.6609L1.65381 8.05924L2.65381 7.93257L3.09612 7.15674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.0385 7.15674L7.48081 7.93257L8.48081 8.05924L7.76927 8.6609L7.92311 9.53174L7.0385 9.12007L6.15388 9.53174L6.30773 8.6609L5.59619 8.05924L6.59619 7.93257L7.0385 7.15674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M10.9809 7.15674L11.4232 7.93257L12.4232 8.05924L11.6924 8.6609L11.8655 9.53174L10.9809 9.12007L10.0963 9.53174L10.2693 8.6609L9.53857 8.05924L10.5386 7.93257L10.9809 7.15674Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.bf1d1736e180cab6108c7161ede63cd3.svg";
export { ForwardRef as ReactComponent };